module.exports = __webpack_public_path__ + "img/footer.d0ef1ccf.webp";